import { Component, OnInit } from '@angular/core';
import { ReportService } from './../../../admin/services/report.service';
import { environment } from 'src/environments/environment';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';

@Component({
  selector: 'app-product-comercial',
  templateUrl: './product-comercial.component.html',
  styleUrls: ['./product-comercial.component.css'],
})
export class ProductComercialComponent implements OnInit {
  datePickerConfig: Partial<BsDatepickerConfig>;

  constructor(private comercial: ReportService) {
    this.datePickerConfig = Object.assign(
      {},
      { containerClass: 'theme-blue', dateInputFormat: 'DD/MM/YYYY' }
    );
  }
  token = window.localStorage.getItem('token');

  productList: any = [];

  showLoading: boolean = true;
  page = 1;
  limit = 1;
  count = 0;
  product__name: string;
  product__ean_code: string;
  product__maker: string;
  provider: string;
  date_created_after;
  date_created_before;
  ngOnInit() {
    this.showLoading = true;

    this.getProductList();
  }

  getProductList() {
    this.comercial
      .getProductList(
        this.page,
        this.product__name,
        this.product__ean_code,
        this.product__maker,
        this.provider
      )
      .toPromise()
      .then((data) => {
        console.log(data);
        this.limit = Math.ceil(data['count']);
        this.count = data['count'];
        this.productList = data['results'];
        this.showLoading = false;
      })
      .catch((error) => console.log(error));
  }

  pageChanged(p) {
    this.page = p.page;
    this.getProductList();
  }

  xslComercialProduct() {
    let initYear =
      (this.date_created_after && this.date_created_after.getFullYear()) || '';

    let initMonth =
      (this.date_created_after &&
        ('0' + (this.date_created_after.getMonth() + 1))
          .toString()
          .slice(-2)) ||
      '';

    let initDay =
      (this.date_created_after &&
        ('0' + this.date_created_after.getDate()).toString().slice(-2)) ||
      '';

    let endYear =
      (this.date_created_before && this.date_created_before.getFullYear()) ||
      '';

    let endMonth =
      (this.date_created_before &&
        ('0' + (this.date_created_before.getMonth() + 1))
          .toString()
          .slice(-2)) ||
      '';

    let endDay =
      (this.date_created_before &&
        ('0' + this.date_created_before.getDate()).toString().slice(-2)) ||
      '';

    let init =
      (this.date_created_after && initYear + '-' + initMonth + '-' + initDay) ||
      '';

    let end =
      (this.date_created_before && endYear + '-' + endMonth + '-' + endDay) ||
      '';
    window.open(
      environment.xslproductComercial +
        '?token=' +
        this.token +
        '&date_created_after=' +
        init +
        '&date_created_before=' +
        end
    );
  }
}
